import { render, staticRenderFns } from "./teacher-list-item.vue?vue&type=template&id=f6567236"
import script from "./teacher-list-item.vue?vue&type=script&lang=js"
export * from "./teacher-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports